import { App as CapacitorApp } from '@capacitor/app';
import { PluginListenerHandle } from '@capacitor/core';
import { useEffect, useRef } from 'react';

import { capacitorService } from '../application/CapacitorService';

export const useDisableAndroidBackButton = () => {
  const eventRef = useRef<PluginListenerHandle | null>(null);
  const lastBackPress = useRef<number>(0);

  useEffect(() => {
    if (eventRef.current === null && capacitorService.isAndroid()) {
      (async () => {
        eventRef.current = await CapacitorApp.addListener(`backButton`, () => {
          const now = Date.now();
          if (now - lastBackPress.current < 300) {
            CapacitorApp.exitApp();
          } else {
            lastBackPress.current = now;
          }
        });
      })();
    }

    return () => {
      if (eventRef.current) {
        eventRef.current.remove();
        eventRef.current = null;
        return;
      }
    };
  }, []);
};
